// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__14_NC","signatureButtonsRight":"ModalSign_signatureButtonsRight__3VFbS"};